import { Stack } from "@mui/material";
import * as Sentry from "@sentry/react";
import { BankButton } from "Components/Shared/BanksList/BankButton/BankButton";
import type { BankEnvironment } from "Infrastructure/Api/Api";
import { mapBankEnvironmentToBank } from "Utils/BankUtils";

type Props = {
  environments: Array<BankEnvironment>;
  authorize: (params: { environment: BankEnvironment }) => void;
  isPending: boolean;
  selectedEnvironment?: BankEnvironment;
};

export const ExpiringBanksList = ({
  environments,
  authorize,
  isPending,
  selectedEnvironment,
}: Props) => {
  // CODE ONLY FOR DEBUGGING PURPOSES - investigating bug e.map is not a function (SENTRY ISSUE MOONE-APP-REACT-CD) -------------------------
  if (!Array.isArray(environments)) {
    Sentry.captureMessage("Malformed environments prop in ExpiringBanksList", {
      level: "error",
      extra: {
        environments,
        typeofEnvironments: typeof environments,
        keys:
          environments && typeof environments === "object"
            ? Object.keys(environments)
            : null,
      },
    });
    return null;
  }
  // ----------------------------------------------------------------------------------------------------------------------------------------

  return (
    <Stack gap={2}>
      {environments.map((environment) => {
        const isLoading = environment === selectedEnvironment && isPending;

        return (
          <BankButton
            key={environment}
            bank={mapBankEnvironmentToBank(environment)}
            onClick={() => authorize({ environment })}
            isLoading={isLoading}
            actionType="reauth"
          />
        );
      })}
    </Stack>
  );
};
